import { jsx, jsxs } from 'react/jsx-runtime';
import { c as classNames } from '../../../../../index-6ea95111.js';
import { s as styleInject } from '../../../../../style-inject.es-1f59c1d0.js';
import { IconRenderer } from '../../IconRenderer/IconRenderer.js';

var css_248z = ".CTACell-module_narrow__1EPPT {\n  height: 40px;\n  padding: 8px !important;\n}";
var styles = {"narrow":"CTACell-module_narrow__1EPPT"};
styleInject(css_248z);

var CTACell = function (_a) {
    var _b;
    var title = _a.title, price = _a.price, icon = _a.icon, grey = _a.grey, narrow = _a.narrow, href = _a.href, buttonCaption = _a.buttonCaption, imageComponent = _a.imageComponent, className = _a.className, dataCy = _a.dataCy, dataTestId = _a.dataTestId;
    var renderedIcon = (jsx(IconRenderer, { icon: icon, imageComponent: imageComponent }));
    return (jsxs("div", { className: classNames(className, "ta-center"), "data-cy": dataCy, "data-testid": dataTestId, children: [jsxs("div", { className: "d-flex jc-center ai-center gap8", children: [renderedIcon, jsxs("p", { className: "p-h3", children: [title, price && jsxs("span", { className: "tc-purple-500", children: [" ", price] })] })] }), jsx("a", { className: classNames('mt16 w100 wmx3', (_b = {
                        'p-btn--primary': !grey,
                        'p-btn--secondary-grey': grey
                    },
                    _b[styles.narrow] = narrow,
                    _b)), href: href, target: "_blank", rel: "noopener noreferrer", children: buttonCaption })] }));
};

export { CTACell };
//# sourceMappingURL=CTACell.js.map
